module.exports = __webpack_public_path__ + "img/best-buy-logo.e2d437f1.png";